export default "__VITE_PUBLIC_ASSET__f5124397__"